<template>
  <template v-if="buybackOffer">
    <AcceptedOffer
      class="mb-8"
      :name="buybackOffer?.product.shortTitle"
      :price="buybackOffer?.listing.price"
      :tier="buybackOffer?.tier"
      @remove="handleRemove"
    />

    <CardGuidance
      v-if="displayGuidance"
      :clickable="true"
      :icon="IconSparkles"
      :label="i18n(translations.swapOfferCardGuidance)"
      :modal-name="PRODUCT_MODAL_NAMES.TRADE_IN"
      @click="handleGuidanceClick"
    />
  </template>

  <NoOfferV2
    v-else
    :model="model || ''"
    with-search-bar
    :zone
    @default-item-selected="$emit('default-item-selected')"
    @item-selected="
      (item) => {
        $emit('item-selected', item)
      }
    "
  />
</template>

<script setup lang="ts">
import type { GetOfferV1Response } from '@backmarket/http-api/src/api-specs-buyback/customer/getOfferV1'
import type { BuybackProduct } from '@backmarket/nuxt-layer-buyback/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { IconSparkles } from '@ds/icons/IconSparkles'

import { MODAL_NAMES as PRODUCT_MODAL_NAMES } from '~/scopes/product/constants'
import CardGuidance from '~/scopes/product-core/components/presentationals/CustomizationFunnel/components/CardGuidance/CardGuidance.vue'

import AcceptedOffer from '../AcceptedOffer/AcceptedOffer.vue'
import NoOfferV2 from '../SwapNoOffer/SwapNoOffer.vue'

import translations from './SwapOffer.translations'

const props = withDefaults(
  defineProps<{
    model?: string
    buybackOffer: GetOfferV1Response | null
    buybackOfferPayload: Record<string, unknown> | null
    displayGuidance?: boolean
    zone: string
  }>(),
  {
    model: undefined,
    displayGuidance: true,
  },
)

const emit = defineEmits<{
  (e: 'item-selected', value: BuybackProduct): void
  (e: 'default-item-selected'): void
  (e: 'remove'): void
}>()

const i18n = useI18n()
const { trackClick } = useTracking()

function handleGuidanceClick() {
  trackClick({
    name: 'post_funnel_info',
    zone: 'swap_pp_block',
    value: {
      ...(props.buybackOfferPayload || {}),
      swap_estimation: parseInt(
        props.buybackOffer?.listing.price.amount || '0',
        10,
      ),
    },
  })
}
function handleRemove() {
  if (props.buybackOffer && props.buybackOfferPayload) {
    trackClick({
      zone: 'swap_pp_block',
      name: 'remove_swap',
      value: {
        swap_estimation: parseInt(props.buybackOffer.listing.price.amount, 10),
        ...props.buybackOfferPayload,
      },
    })
  }

  emit('remove')
}
</script>
